import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Table from 'src/components/Table';
import TableCell from 'src/components/Table/TableCell';
import NotFoundRecords from 'src/components/NotFoundRecords';
import CreditCardsRow from './CreditCardsRow';

const Tbody = ({ creditCards, clientId }) => {
  return creditCards.map(card => (
    <CreditCardsRow key={card.id} {...card} clientId={clientId} />
  ));
};

const CreditCardsTable = ({ creditCards, loading, clientId, ...rest }) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow component="tr">
        <TableCell variant="head" key="brand" align="center">
          {t('CLIENTS_VIEW.BILLING_DETAIL.BRAND')}
        </TableCell>
        <TableCell variant="head" key="card-number" align="center">
          {t('CLIENTS_VIEW.BILLING_DETAIL.CARD_NUMBER')}
        </TableCell>
        <TableCell variant="head" key="bank" align="center">
          {t('CLIENTS_VIEW.BILLING_DETAIL.BANK')}
        </TableCell>
        <TableCell variant="head" key="expiration-date" align="center">
          {t('CLIENTS_VIEW.BILLING_DETAIL.EXPIRATION_DATE')}
        </TableCell>
        <TableCell variant="head" key="actions" align="right">
          {}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(
    () => () => <Tbody creditCards={creditCards} clientId={clientId} />,
    [creditCards, clientId]
  );

  if (!loading && (!creditCards || creditCards.length === 0)) {
    return (
      <Card>
        <NotFoundRecords
          title="CLIENTS_VIEW.BILLING_DETAIL.NO_CREDIT_CARDS"
          description="COMMON.NO_RECORDS_FOUND"
        />
      </Card>
    );
  }

  return (
    <Table
      style={{ tableLayout: 'fixed', width: '100%' }}
      {...rest}
      tbody={tbody}
      theads={theads}
      loading={loading}
    />
  );
};

CreditCardsTable.propTypes = {
  creditCards: PropTypes.array,
  loading: PropTypes.bool,
  clientId: PropTypes.string.isRequired
};

export default CreditCardsTable;
